export default {
  newClass: 'Nueva clase',
  createClass: 'Crear clase',
  index: 'Índice',
  classPlanDescription: 'Plan de clases',
  media: 'Imagen o video disparador',
  pedagogicalGoal: 'Objetivo pedagógico',
  studentPedagogicalGoal: 'Objetivo pedagógico',
  trigger: 'Punto de partida',
  organization: 'Organización',
  statement: 'Consigna',
  class: 'Clase',
  startSection: 'Inicio',
  developmentSection: 'Desarrollo',
  closureSection: 'Cierre',
  necessaryMaterials: 'Vas a necesitar',
  valuationSection: 'Sugerencias de evaluación',
  globalValuation: 'Sugerencias de evaluación del recurso',
  studentPreview: 'Vista previa del estudiante',
  necessaryDownloadableMaterials: 'Contenido descargable',
  deleteClassModal: {
    title: '¿Eliminar la clase {classNumber}?',
    message: 'Al presionar eliminar se borrará la clase y no se podrá recuperar.',
    allClass: 'Eliminar toda la clase',
    warning: 'Al presionar eliminar se borrará la clase del docente y del alumno.',
    typeConfirmTeacher: 'Para confirmar, escribe debajo <i>"borrar clase docente"</i>',
    typeConfirmStudent: 'Para confirmar, escribe debajo <i>"borrar clase estudiante"</i>',
    typeConfirmAll: 'Para confirmar, escribe debajo <i>"borrar clase completa"</i>',
    teacherPlaceholder: 'borrar clase docente',
    studentPlaceholder: 'borrar clase estudiante',
    allPlaceholder: 'borrar clase completa',
    confirmError: 'El texto ingresado no coincide con lo esperado',
    rightLabel: 'Eliminar'
  },
  rhetoricalQuestion: 'Pregunta disparadora'
}

export const en = {
  newClass: 'New class',
  createClass: 'Create class',
  index: 'Table of contents',
  classPlanDescription: 'Lesson Plan',
  media: 'Image or video trigger',
  pedagogicalGoal: 'Educational goal',
  studentPedagogicalGoal: 'Educational goal',
  trigger: 'Starting point',
  organization: 'Organization',
  statement: 'Assignment',
  class: 'Class',
  startSection: 'Start',
  developmentSection: 'Development',
  closureSection: 'Closure',
  necessaryMaterials: 'You will need',
  valuationSection: 'Suggested evaluation',
  globalValuation: 'Suggestions for resource evaluation',
  studentPreview: 'Student preview',
  necessaryDownloadableMaterials: 'Downloadable content',
  deleteClassModal: {
    title: 'Delete class {classNumber}?',
    message: 'Pressing delete will remove the class and it cannot be recovered.',
    allClass: 'Delete the entire class',
    warning: 'Pressing delete will remove the class from both the teacher and the student.',
    typeConfirmTeacher: 'To confirm, type below <i>"delete teacher class"</i>',
    typeConfirmStudent: 'To confirm, type below <i>"delete student class"</i>',
    typeConfirmAll: 'To confirm, type below <i>"delete complete class"</i>',
    teacherPlaceholder: 'delete teacher class',
    studentPlaceholder: 'delete student class',
    allPlaceholder: 'delete complete class',
    confirmError: 'The entered text does not match the expected',
    rightLabel: 'Delete'
  },
  rhetoricalQuestion: 'Triggering question'
}

export const ca = {
  newClass: 'Nova classe',
  createClass: 'Crear classe',
  index: 'Índex',
  classPlanDescription: 'Pla de classes',
  media: 'Imatge o vídeo disparador',
  pedagogicalGoal: 'Objectiu pedagògic',
  studentPedagogicalGoal: 'Objectiu pedagògic',
  trigger: 'Punt de partida',
  organization: 'Organització',
  statement: 'Consigna',
  class: 'Classe',
  startSection: 'Inici',
  developmentSection: 'Desenvolupament',
  closureSection: 'Tancament',
  necessaryMaterials: 'Necessitaràs',
  valuationSection: 'Suggeriments d\'avaluació',
  globalValuation: 'Suggeriments d\'avaluació del recurs',
  studentPreview: 'Vista prèvia de l\'estudiant',
  necessaryDownloadableMaterials: 'Contingut descarregable',
  deleteClassModal: {
    title: 'Eliminar la classe {classNumber}?',
    message: 'En prémer eliminar, la classe serà esborrada i no es podrà recuperar.',
    allClass: 'Eliminar tota la classe',
    warning: 'En prémer eliminar, la classe serà esborrada tant del docent com de l\'alumne.',
    typeConfirmTeacher: 'Per confirmar, escriu a continuació <i>"esborrar classe docent"</i>',
    typeConfirmStudent: 'Per confirmar, escriu a continuació <i>"esborrar classe estudiant"</i>',
    typeConfirmAll: 'Per confirmar, escriu a continuació <i>"esborrar classe completa"</i>',
    teacherPlaceholder: 'esborrar classe docent',
    studentPlaceholder: 'esborrar classe estudiant',
    allPlaceholder: 'esborrar classe completa',
    confirmError: 'El text introduït no coincideix amb l\'esperat',
    rightLabel: 'Eliminar'
  },
  rhetoricalQuestion: 'Pregunta disparadora'
}
